// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"fc16cd73","268":"50fd43ba","752":"b675bc8c","883":"225e125d"}[chunkId] + ".chunk.css";
};